module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign_wrap"
  }, [(!_vm.isAgreement) ? _c('el-button', {
    staticClass: "start_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("开始入驻")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "f666 tc"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "up_info mt20"
  }, [_c('p', {
    staticClass: "fwb"
  }, [_vm._v("三.入驻常见问题")]), _vm._v(" "), _c('ul', {
    staticClass: "q_and_a"
  }, _vm._l((_vm.questions), function(val, index) {
    return _c('li', [_c('a', {
      staticClass: "questions",
      class: {
        'actives': _vm.num === index
      },
      on: {
        "click": function($event) {
          _vm.skan_q(index)
        }
      }
    }, [_vm._v(_vm._s(val))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [(_vm.num === 0) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "width": "660",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/1.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.num == 1) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("为了方便系统快速将申请入驻的供应商分配给对应的采销审核，商家入驻的品类如果涉及到多个采销部门运营的品类，系统会限制供应商先申请一个部门运营的品类。待入驻成功后，供应商可以再申请入驻其他品类。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.num == 2) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(4), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table1,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "文件名称",
      "min-width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cata",
      "label": "资质要求及涉及品类",
      "width": "180",
      "align": "center"
    }
  })], 1), _vm._v(" "), _vm._m(5)], 1) : _vm._e(), _vm._v(" "), (_vm.num == 3) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(6), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.table2,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "文件名称",
      "min-width": "180",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cata",
      "label": "资质要求及涉及品类",
      "min-width": "180",
      "align": "center"
    }
  })], 1), _vm._v(" "), _vm._m(7)], 1) : _vm._e(), _vm._v(" "), (_vm.num == 4) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(8), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("申请主营品牌分为两种方式：（1）申请大V店品牌库中已有的品牌；（2）审核添加大V店品牌库未录入的品牌。")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/5-1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("在右上角搜索框输入品牌关键字，点击搜索，查看大V店品牌库是否已经录入品牌。")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("如果搜索到需要的品牌，点击勾选：")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/5-2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("点击【确定】，选中品牌。确定品牌之后，为该品牌绑定之前申请主营的品类：")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "86%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/5-3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "main_word",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("重点：非图书品类的供应商，按照页面提示填写信息，上传页面要求的品牌相关的证件。")]), _vm._v(" "), _c('p', {
    staticClass: "main_word",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("图书品类不需要绑定品类和上传证件")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("没有搜索到申请的品牌，可以添加您要主营的品牌：")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/5-4.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("输入品牌的“中文名称”“英文名称”“品牌介绍”“重点商品链接（淘宝、天猫、京东等平台的商品链接）”。")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("然后和第（1）中类型一样，绑定主营的品类和填写相应品牌信息、上传相应证件")]), _vm._v(" "), _c('p', {
    staticClass: "main_word",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("可以申请多个品牌。")])]) : _vm._e(), _vm._v(" "), (_vm.num == 5) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("供应商申请入驻的品类，每一个品类至少绑定一个申请主营的品牌，否则不能提交审核。\n\t\t\t\t\t比如您申请入驻2个品类：个护化妆—面部护肤—面膜，个护化妆—面部护肤—眼部护理。\n\t\t\t\t\t申请主营品牌为“丽得姿”，在品牌页面您只给品牌绑定了“个护化妆—面部护肤—面膜”，如下所示：\n\t\t\t\t")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/6-1.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/6-2.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/6-3.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.num == 6) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("提交审核之后，进入初审。等待采销审核。\n\t\t\t\t\t初审通过之后，大V店会短信、邮件通知您初审通过。等待采销编辑和合同协议，您再确认合同。\n\t\t\t\t\t初审驳回，大V店会短信、邮件通知您驳回及驳回原因。您可以登录查看进展和驳回原因、修改申请信息，再次提交审核。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.num == 7) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("采销编辑完成合同，推送给供应商审核。供应商会收到邮件和短信提示。登录大V服务平台，进入【合同协议】页面，可以查看合同信息：")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/8-1.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/8-2.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/8-3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "width": "84%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/8-4.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(19)]) : _vm._e(), _vm._v(" "), (_vm.num == 8) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("对合同内容有疑问，不同意合同。可以驳回合同。点击【合同协议】列表的【不同意合同】，输入原因，系统会反馈到大V店采销：")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/9.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.num == 9) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(21), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("填写完成线上合同内容，并且同意合同内容。点击合同协议列表页面的【同意合同】，进入复审。复审主要是大V店的财务、法务人员审核所有合同、资质信息。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.num == 10) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(22), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("供应商同意合同之后，进入入驻复审流程。等待品类总监、法务、财务复审。")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("（1）如果供应商资质信息不正确，复审驳回会直接驳回给供应商修改。\n\t\t\t\t\t系统会邮件、短信通知供应商。供应商登录后查看驳回原因，修改可修改的信息，重新提交等待再次复审。")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("（2）如果法务审核合同协议不过关，系统会驳回给采销，由采销修改合同。然后推送给供应商确认修改的合同。\n\t\t\t\t\t供应商同意修改后的合同内容，再次进入复审。\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.num == 11) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(23), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("复审通过之后，等到供应商的保证金（有些品类不需要交保证金）到账、纸质合同邮寄到大V店。系统会开通供应商注册账号的供应商使用权限。\n\t\t\t\t\t系统会短信、邮件通知供应商。\n\t\t\t\t\t重新登录后，即可使用大V服务平台相关功能，添加商品、管理订单等。")])]) : _vm._e(), _vm._v(" "), (_vm.num == 12) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(24), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("登录大V服务平台，可以随时在页面查看入驻进展：")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "80%",
      "src": "http://mamaj-oss.oss-cn-beijing.aliyuncs.com/free/Jia/13.png",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.num == 13) ? _c('div', {
    staticClass: "tab"
  }, [_vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "text_intro",
    attrs: {
      "align": "left"
    }
  }, [_vm._v("入驻申请或提交初审前，如有任何疑问，可邮件询问“bd@davdian.com”或”cm@davdian.com”；提交初审后，会有对接采销与您联系，相关问题可直接询问对接采销。")])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "未登录",
      "visible": _vm.tipDialog,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.tipDialog = $event
      }
    }
  }, [_c('span', [_vm._v("入驻前请先登录")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.tipDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/suppliers/index"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("去登录")])], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_c('p', {
    staticClass: "fwb"
  }, [_vm._v("一.入驻流程")]), _vm._v(" "), _c('p', [_vm._v("入驻申请→初审→编辑线上合同→复审→缴纳保证金→提交纸质材料→开通后台账号；")]), _vm._v(" "), _c('p', [_vm._v("注：每一个环节的状态，系统都会邮件或短信告知商家，商家也可以登入注册账号进行查询。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "up_info mt20"
  }, [_c('p', {
    staticClass: "fwb"
  }, [_vm._v("二.入驻须知")]), _vm._v(" "), _c('p', [_vm._v("(1) 商家入驻的品类如果涉及到多个部门，系统仅允许“先”入驻一个部门负责的品类，待入驻成功后方可入驻其他品类；")]), _vm._v(" "), _c('p', [_vm._v("(2) 商家申请主营品牌有两种方式：第一种，选择大V店品牌库已有的品牌；第二种，手动输入大V店品牌库还未录入的品牌信息。商家需优先采用第一种方式，如果品牌库搜索不到，再采用第二种方式；")]), _vm._v(" "), _c('p', [_vm._v("(3) 非图书品类的每一个品牌均需选择要入驻的品类，未选择入驻的品类，后期创建商品信息则无法创建成功；")]), _vm._v(" "), _c('p', [_vm._v("(4) 入驻申请或提交初审前，如有任何疑问，可邮件询问“bd@davdian.com”；提交初审后，会有对接采销与您联系，相关问题可直接询问对接采销；")]), _vm._v(" "), _c('p', [_vm._v("(5) 商家入驻多个品类，只需缴纳一份保证金，保证金取多个品类中最高的。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb10"
  }, [_c('strong', [_vm._v("1. 入驻流程介绍。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("2. 在供应商信息页面，为什么申请主营品类时候总是提示只能申请一个部门的品类？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("3. 有些品类需要上传“品类经营特许资质”，这个是什么？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("所有证件格式要求：证件复印件，然后加盖公司红章，再扫描上传。图片格式支持JPG/GIF/PNG，每张图片大小不得超过1M。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("4. 基本资质证件说明。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("证件复印件，然后加盖公司红章，再扫描上传。”图片格式支持JPG/GIF/PNG，每张图片大小不得超过1M。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("5. 如何申请主营的品牌？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("（1）申请大V店品牌库已有的品牌")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("（2）申请添加新品牌")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("6. 为什么在点击【提交审核】时，页面提示“所有品类信息至少要绑定一个品牌”？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt10 mb10",
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("这个时候提交审核时候，系统就会提示：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mt10",
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("因为申请的另一个品类“个护化妆—面部护肤—眼部护理”没有绑定任何品牌，所以不能提交。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb10",
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("在品牌详情页绑定品类和品牌的关系：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("7. 提交审核之后，接下来供应商应该做什么事情？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("8. 供应商在确认合同过程中，应该做什么？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb20 text_intro",
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("点击【查看详情】，查看合同详细内容：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "mb10 text_intro",
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("点击合同协议页面的【线上合同信息】后面的【编辑】按钮，供应商填写“乙方”需要填写的合同信息：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "main_word text_intro",
    attrs: {
      "align": "left"
    }
  }, [_c('strong', [_vm._v("所有“粉色”下划线处，都是需要供应商编辑的信息。请仔细阅读合同内容并填写信息。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("9. 供应商对合同内容有异议，应该怎么做？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("10. 供应商对合同没有疑问，应该怎么做？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("11. 同意合同之后，供应商还需要做什么？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("12. 复审通过之后，供应商审核时候可以使用大V服务平台添加商品？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("13. 供应商如何查看入驻进展？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("14. 如何联系大V店工作人员？")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58332266"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/intro.vue
// module id = 531
// module chunks = 0